import { createRouter, createWebHistory } from "vue-router";
import store from "../src/store/index.js";

//import website
import homePage from "../src/views/home.vue";
const bookPage = () => import('../src/views/booking.vue');
const loginPage = () => import('../src/views/auth/login.vue');
const setPasswordPage = () => import('../src/views/auth/set_password.vue');
const ForgetPasswordPage = () => import('../src/views/auth/forget_password.vue');
const OtpPage = () => import('../src/views/auth/otp.vue');
const resetPasswordPage = () => import('../src/views/auth/reset_password.vue');
const NotFound = () => import('../src/views/error.vue');

const profilePage = () => import('../src/views/profile/profile.vue');
const employeePage = () => import('../src/views/profile/employee.vue');
const passwordPage = () => import('../src/views/profile/password.vue');
const bookingPage = () => import('../src/views/profile/booking.vue');
const papersPage = () => import('../src/views/profile/papers.vue');

const routes = [
  // Website routes
  { path: "/", component: homePage, name: "home", meta: { layout: "public" } },
  { path: "/book", component: bookPage, name: "book", meta: { layout: "public" } },
  {
    path: "/login",
    component: loginPage,
    name: "login",
    meta: { guest: true, layout: "auth", titleKey: "auth.loginPageTitle" },
  },
  {
    path: "/set_password",
    component: setPasswordPage,
    name: "setPassword",
    meta: { guest: true, layout: "auth", titleKey: "auth.setPageTitle" },
  },
  {
    path: "/forget_password",
    component: ForgetPasswordPage,
    name: "ForgetPassword",
    meta: { guest: true, layout: "auth", titleKey: "auth.forgotPageTitle" },
  },
  { path: "/otp", component: OtpPage, name: "Otp", meta: { guest: true, layout: "auth", titleKey: "auth.otpPageTitle" } },
  {
    path: "/reset_password",
    component: resetPasswordPage,
    name: "resetPassword",
    meta: { guest: true, layout: "auth", titleKey: "auth.resetPageTitle" },
  },
  {
    path: "/profile",
    component: profilePage,
    name: "profile",
    meta: { requiresAuth: true, layout: "portal", titleKey: "portal.profileTitle" },
  },
  {
    path: "/employee",
    component: employeePage,
    name: "employee",
    meta: { requiresAuth: true, layout: "portal", titleKey: "portal.employeesTitle" },
  },
  {
    path: "/password",
    component: passwordPage,
    name: "password",
    meta: { requiresAuth: true, layout: "portal", titleKey: "portal.passwordTitle" },
  },
  {
    path: "/booking",
    component: bookingPage,
    name: "booking",
    meta: { requiresAuth: true, layout: "portal", titleKey: "portal.bookingsTitle" },
  },
  {
    path: "/booking-papers",
    component: papersPage,
    name: "papers",
    meta: { requiresAuth: true, layout: "portal", titleKey: "portal.papersTitle" },
  },
  { path: "/404", component: NotFound, meta: { layout: "public" } },
  { path: "/:catchAll(.*)", redirect: "/404" },
];

// The component showcase is excluded from production builds.
if (process.env.NODE_ENV === 'development') {
  routes.unshift({
    path: '/__design-system',
    name: 'designSystemPreview',
    component: () => import('../src/dev/DesignSystemPreview.vue'),
    meta: { layout: 'showcase' },
  });
}

const router = createRouter({
  routes,
  history: createWebHistory(),
  hashbang: false,
  mode: "history",
  linkActiveClass: "active",
  // linkExactActiveClass: "exact-active",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    if (to.hash && to.meta.layout === 'public') return { el: to.hash, top: 112, behavior };
    return { top: 0, behavior };
  },
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isAuthenticated) {
      next();
      return;
    }
    next("/login");
  } else {
    next();
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.guest)) {
    if (store.getters.isAuthenticated) {
      next("/profile");
      return;
    }
    next();
  } else {
    next();
  }
});

export default router;
